import styled, { css } from "styled-components";
import { DARK_GRAY, DINGY_GRAY, LIGHT_BLUE, NEAR_WHITE } from "../../config";

export const Items = styled.div`
  position: absolute;
  z-index: 9999;
  min-width: 10rem;

  background: ${DINGY_GRAY};
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.25), 0px 6px 30px rgba(0, 0, 0, 0.25),
    0px 8px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  overflow: hidden;
`;

export const Item = styled.a<{ disabled?: boolean }>`
  color: ${NEAR_WHITE};
  text-decoration: none;
  margin: 16px;
  display: block;
  cursor: pointer;

  &:hover {
    color: ${LIGHT_BLUE};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${DARK_GRAY};
      cursor: not-allowed;

      &:hover {
        color: ${DARK_GRAY};
      }
    `}
`;
